import './index.scss';

import React from 'react';
import {validateForm} from "../../../../util/validation";

import Form from "../../form";
import TextInput from "../../../atoms/text-input";
import DataValue from "../../data-value";

/**
 * Applies one of the POS discounts to a cart. Either a promo code flagged POS only
 * in the CMS, where only a note can be added, or a free amount that needs one.
 *
 * Form builds a ref per child in its constructor and reads child.type before it
 * guards for empty ones, so it only ever gets real fields here, never a conditional
 * that renders false.
 */
class ManualDiscountCreate extends React.Component {

    static defaultProps = {
        promoCode: null,
        onSave: (data) => {},
    };

    constructor(props) {
        super(props);

        this.form = React.createRef();
    }

    isAmountDiscount() {
        return ! this.props.promoCode;
    }

    validateForm(form, data) {
        if (! this.isAmountDiscount()) {
            return;
        }

        validateForm(form, data, {
            amount: ['required'],
            note: ['required'],
        });
    }

    onSubmit(data) {
        if (this.isAmountDiscount()) {
            this.props.onSave({
                amount: data.amount,
                note: data.note,
            });

            return;
        }

        this.props.onSave({
            promo_code: this.props.promoCode.id,
            note: data.note,
        });
    }

    render() {
        if (this.isAmountDiscount()) {
            return (
                <Form
                    ref={this.form}
                    validate={(form, data) => this.validateForm(form, data)}
                    onSubmit={(data) => this.onSubmit(data)}
                    showSubmitButton={false}
                >
                    <TextInput name="amount" label="Amount" type="number" showRequiredIndicator={true}/>
                    <TextInput name="note" label="Note" showRequiredIndicator={true}/>
                </Form>
            );
        }

        return (
            <div className="manual-discount-create">
                <DataValue title="Discount">
                    {this.props.promoCode.formatted_discount}
                </DataValue>
                <div className="manual-discount-create__form">
                    <Form
                        ref={this.form}
                        validate={(form, data) => this.validateForm(form, data)}
                        onSubmit={(data) => this.onSubmit(data)}
                        showSubmitButton={false}
                    >
                        <TextInput name="note" label="Note"/>
                    </Form>
                </div>
            </div>
        );
    }
}

export default ManualDiscountCreate;
